import React, { createContext, useContext, useState, useEffect } from 'react';
import { useRealAccounts } from '../hooks/useRealAccounts';
import { getAccountDetails } from '../api/tradingApi';

const TradingAccountContext = createContext();

export const useTradingAccount = () => useContext(TradingAccountContext);

export const TradingAccountProvider = ({ children }) => {
    const { accounts, loadingAccounts } = useRealAccounts();
    const [selectedAccount, setSelectedAccount] = useState('');
    const [accountData, setAccountData] = useState(null);
    const [accountError, setAccountError] = useState(null);
    const [loadingAccountData, setLoadingAccountData] = useState(false);

    // Initialize selected account when accounts load
    useEffect(() => {
        if (accounts && accounts.length > 0 && !selectedAccount) {
            setSelectedAccount(accounts[0].account_number || accounts[0]);
        }
    }, [accounts, selectedAccount]);

    useEffect(() => {
        if (selectedAccount) {
            fetchAccountDetails(selectedAccount);
        }
    }, [selectedAccount]);

    const fetchAccountDetails = async (accId) => {
        try {
            setLoadingAccountData(true);
            setAccountData(null);
            setAccountError(null);
            const res = await getAccountDetails(accId);
            if (res && res.status === 'success') {
                setAccountData(res.data);
            } else if (res && res.status === 'error') {
                setAccountError(res.message || "Account not found");
            } else if (res && res.code === 404) {
                setAccountError(res.message || "Account not found");
            }
        } catch (error) {
            if (error.response && error.response.data && error.response.data.message) {
                setAccountError(error.response.data.message);
            } else if (error.message) {
                setAccountError(error.message);
            } else {
                setAccountError("Failed to fetch account details");
            }
        } finally {
            setLoadingAccountData(false);
        }
    };

    return (
        <TradingAccountContext.Provider value={{
            accounts,
            loadingAccounts,
            selectedAccount,
            setSelectedAccount,
            accountData,
            accountError,
            loadingAccountData
        }}>
            {children}
        </TradingAccountContext.Provider>
    );
};
